export default "__VITE_ASSET__CvzUWN$Y__"